<svelte:options tag="and-menu-item"></svelte:options>
<style style type="text/scss" lang="scss">
  @import "../../../global.scss";

  .menu-item {
    float: left;
    @include fontSize(14px);
    font-family: "Poppins", sans-serif;
    color: $and-charcoal;
    text-align: center;
    padding: toRem(14px) toRem(16px) 0 toRem(16px);
    text-decoration: none;
    
  }
  .menu-item:hover {
    font-weight: bold;
  }


  .menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @include large-screen {
      float: left;
      flex-direction: row;
    }
  }

  .dropdown {
    font-family: "Poppins", sans-serif;
    /* overflow: hidden; */
    display: flex;
    flex-direction: column;

    position: relative;
    /* float: left; */
  }

  .dropbtn {
    @include fontSize(14px);
    font-family: "Poppins", sans-serif;
    border: none;
    outline: none;
    color: $and-charcoal;
    padding: toRem(14px) toRem(16px) 0 toRem(16px);
    background-color: inherit;
    font-family: inherit;
    margin: 0;
    display: flex;

    i{
        @include gg-play-button;
        @include large-screen {
          @include expand-button;
        }
    }

    &:hover i{
      @include expand-button;
    }
    
    @include large-screen {
      padding-bottom: toRem(45px);
    }
  }

  .dropbtn:hover {
    font-weight: bold;
  }

  .dropdown-content {
      display: none;
      margin-left: 1.5rem;

    @include large-screen {
      background-color: white;
      margin: 0.5rem;
      box-shadow: toRem(0px) toRem(8px) toRem(16px) toRem(0px)
        rgba(0, 0, 0, 0.2);
      position: absolute;
      width: 100%;
      margin-top: toRem(45px);
      z-index: 1;
    }
  }

  .dropdown-content a {
    font-family: "Poppins", sans-serif;
    color: black;
    padding: toRem(12px) toRem(16px);
    text-decoration: none;
    display: block;
    text-align: left;
  }

  .dropdown-content a:hover {
      background-color: $and-blue;
  }

  .dropdown:hover .dropdown-content, .dropdown:hover .menu-separator {
    display: block;
  }

  .menu-separator {
    display:none;
    width: 82vw;
    border-width: 0;
    margin-top: 1rem;
    border-top: 1px solid $and-charcoal;
    margin-left: toRem(14px);
  }
</style>

<script>
  import Phone from "../../../breakpoints/Phone.svelte";
  export let text = "";

  export let href = "";

export let id = 'and-menu-item';

export let target ='';

export let menuseparator = true;

  let subMenu;
</script>


<div class="menu">
  {#if href == ''}
  <div id="{id}" class="dropdown">
    <button class="dropbtn">{text}
    <i></i>
  </button>
    <div class="dropdown-content" bind:this={subMenu}>
      <slot>
        <b>No Sub-Menu provided</b>
      </slot>
    </div>

    <Phone>
      {#if menuseparator === true}
        <hr class="menu-separator">
      {/if}
    </Phone>
  </div>
  {/if} {#if href != ''}
  <a id="{id}" class="menu-item" target="{target}" href="{href}">{text}</a>
  {/if}
</div>